import Vue from 'vue'
import axios from './vue-axios/axios'

export function searchUsers(params){
  return Vue.axios.get(process.env.API_URL + '/v1/users/search', {params: params})
}

export function loadServicesMail() {
  return Vue.axios.get(process.env.API_URL + '/v1/users/services_mail')
}

export function getUser(userId, entityId){
  return axios.get(process.env.API_URL + '/v1/users/' + userId + '?entity_id=' + entityId);
}

export function createUser(user){
  return axios.post(process.env.API_URL + '/v1/users', { user: processAttributes(user) })
}

export function createUserPublicly(user){
  return axios.post(process.env.API_URL + '/v1/users/signup', { user: processAttributes(user) })
}

export function validateStatusEmail(email){
  return axios.get(process.env.API_URL + '/v1/users/email/find_by_email', { params: { email: email }});
}

export function sendMailCandidate(email){
  return axios.post(process.env.API_URL + '/v1/users/send_mail_candidate', { email: email });
}

export function updateUser(user){
  return axios.put(process.env.API_URL + '/v1/users/' + user.id, { user: processAttributes(user) })
}

export function getManageableResources(entityId, hubIds = null, hubOption = 'all'){
  var params = { entity_id: entityId, hub_ids: hubIds, hub_option: hubOption };
  return Vue.axios.get(process.env.API_URL + '/v1/manageable_resources', { params: params });
}

export async function getManageableResourcesWithEntityCode(entityCode, email) {
  let params = { email: email }
  return await Vue.axios.get(process.env.API_URL + '/v1/entities/by_code/' + entityCode, { params });
}

export function notDisturb(date){
  return Vue.axios.post(process.env.API_URL + '/v1/users/me/not_disturb', { date: date })
}

export function updateProfile(user){
  return Vue.axios.put(process.env.API_URL + '/v1/users/me', { user: processAttributes(user) });
}

export function deleteUser(userId, entityIds){
  let params = { entity_ids: entityIds }
  return Vue.axios.delete(`/v1/users/${userId}`, { params })
}

export function recallUser(entityId, userId){
  let params = { entity_id: entityId }
  return Vue.axios.post(`/v1/users/${userId}/recall`, params)
}

export function activateUser(entityIds, userId){
  let params = { entity_ids: entityIds }
  return Vue.axios.post(`/v1/users/${userId}/activate`, params)
}

export function getEntitiesForMultiAction(userId, action) {
  let params = { action: action }
  return Vue.axios.get(`/v1/users/${userId}/entities_for_multi_action`, { params })
}

export function getCoworkers(entity_id){
  var params = { entity_id: entity_id };
  return Vue.axios.get('/v1/users/me/coworkers', { params: params })
}

export function getDestroyUserPermission(userId, entityId){
  let params = { entity_id: entityId }
  return Vue.axios.get('/v1/users/' + userId + '/destroy_permission', { params });
}

export function downloadUsers(params){
  return Vue.axios.get(`${process.env.API_URL}/v1/users/export`, {
    params: { ...params, file_type: params['file_type'] },
    responseType: 'arraybuffer'
  })
}
function processAttributes(user){
  if (user.affiliated_service && user.resource_type == 'intern') {
    user.affiliated_service_id = user.affiliated_service.id
  }
  if (user.services){
    user.service_ids = user.services.map(service => service.id)
  }
  if (user.occupations){
    user.occupation_ids = user.occupations.map(occupation => occupation.id)
  }
  if (user.add_ons) {
    user.add_ons.forEach(add_on => {
      if (add_on.affiliated_service) {
        add_on.affiliated_service_id = add_on.affiliated_service.id
      }
      if (add_on.services) {
        add_on.service_ids = add_on.services.map(service => service.id)
      }
      if (add_on.occupations) {
        add_on.occupation_ids = add_on.occupations.map(occupation => occupation.id)
      }

      if (add_on.entity) {
        add_on.entity_id = add_on.entity.id
      }
    })
  }
  return user
}

export function getManagersForSharing(){
  return Vue.axios.get('/v1/users/me/list_for_sharing_offer')
}

export function shareOfferToSelectedManagers(params){
  return Vue.axios.post('/v1/users/share_offer_to_selected_managers', params)
}

export function getUserWithEntities(corporationId){
  return Vue.axios.get('/v1/users/me/with_entities', { params: { corporation_id: corporationId } })
}

export function checkUserExistenceInEntity(params) {
  return Vue.axios.get('/v1/users/email/existence_in', { params })
}

export function getCorporationUnavailabilityDatesProviderId(userId, entityId) {
  return Vue.axios.get(`/v1/users/${userId}/corporation_unavailability_dates_provider_id`, {
    params: { entity_id: entityId }
  })
}



// WEBPACK FOOTER //
// ./src/backend/users.js